export const openURL = () => {
    return new Promise<void>((resolve) => {
        let hasFocus = true;
        let didHide = false;
        let pageHidden = false;

        const isMac =
            window.navigator.userAgent.indexOf('Mac') !== -1 &&
            window.navigator.maxTouchPoints < 1;
        const hasSafariUserAgent =
            window.navigator.userAgent.indexOf('Safari') > -1;

        const onBlur = () => {
            hasFocus = false;
        };

        const onVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                didHide = true;
            }
        };

        const onPageHide = () => {
            pageHidden = true; // Directly set when the page is being hidden.
        };

        const onPageShow = () => {
            pageHidden = false; // Reset when the page becomes visible again.
        };

        const onFocus = () => {
            if (didHide) {
                resolve();

                didHide = false; // Reset for the next attempt.
            } else {
                // Ignore duplicate focus event when returning from native app on iOS Safari 13.3+
                if (!hasFocus) {
                    // When the app switch transition is fully complete, then 'visibilitychange' will fire.
                    setTimeout(() => {
                        // If the page remains visible and focused, the app launch has failed.
                        if (!didHide && !pageHidden) {
                            resolve();
                        }
                    }, 1000);
                }
            }

            hasFocus = true;
        };

        const bindEvents = () => {
            (<[Window | Document, string, EventListenerOrEventListenerObject][]>[
                [window, 'blur', onBlur],
                [window, 'pagehide', onPageHide],
                [document, 'visibilitychange', onVisibilityChange],
                [window, 'focus', onFocus],
                [window, 'pageshow', onPageShow]
            ]).forEach(([el, event, callback]) => {
                el.addEventListener(event, callback);
            });
        };

        bindEvents();

        const launchWebkitApproach = (url: string) => {
            const dialogTimeout = 500;

            setTimeout(() => {
                if (hasFocus) {
                    resolve();
                }
            }, dialogTimeout);

            window.location.href = url;
        };

        const launchIframeApproach = (url: string) => {
            const dialogTimeout = 500;
            const iframe = document.createElement('iframe');
            iframe.style.border = 'none';
            iframe.style.width = '1px';
            iframe.style.height = '1px';
            iframe.onload = function() {
                document.location = url;
            };
            iframe.src = url;

            document.body.appendChild(iframe);

            setTimeout(() => {
                if (hasFocus) {
                    resolve();
                }
            }, dialogTimeout);
        };

        if (hasSafariUserAgent && isMac) {
            launchIframeApproach('xpoint://launch');
        } else {
            launchWebkitApproach('xpoint://launch');
        }

        setTimeout(resolve, 3000);
    });
};
